// src/Admin/SetOffer.jsx
import React, { useState, useEffect } from "react";

export default function SetOffer() {
  const [offers, setOffers] = useState({
    first_time_percent: "",
    gt_100_percent: "",
    gt_500_percent: "",
    gt_1000_percent: "",
    gt_2000_percent: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const ADMIN_TOKEN = "7a8b9c0d1e2f3g4h5i6j7k8l9m0n1o2p3q4r5s6t";

  useEffect(() => {
    fetch("/offer/get/")
      .then((r) => r.json())
      .then((data) => setOffers(data))
      .catch(() => {
        setOffers({
          first_time_percent: "10",
          gt_100_percent: "5",
          gt_500_percent: "8",
          gt_1000_percent: "12",
          gt_2000_percent: "15",
        });
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOffers((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("/offer/set/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: ADMIN_TOKEN,
        },
        body: JSON.stringify(offers),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage("SUCCESS: All offers updated!");
      } else {
        setMessage("ERROR: " + (data.error || JSON.stringify(data)));
      }
    } catch (err) {
      setMessage("Server is down. Try again.");
    }

    setLoading(false);
  };

  const tiers = [
    { label: "First-time buyer %", name: "first_time_percent" },
    { label: "Order > ₹100 %", name: "gt_100_percent" },
    { label: "Order > ₹500 %", name: "gt_500_percent" },
    { label: "Order > ₹1 000 %", name: "gt_1000_percent" },
    { label: "Order > ₹2 000 %", name: "gt_2000_percent" },
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4 font-[Roboto]">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 text-center mb-10">
          Manage Global Discount Offers
        </h1>

        {/* CARD */}
        <div className="bg-white shadow-md rounded-2xl p-8 border border-gray-200">
          <form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-6">
            {tiers.map(({ label, name }) => (
              <div key={name} className="flex flex-col">
                <label className="text-gray-800 font-medium mb-2">{label}</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="0.01"
                  name={name}
                  value={offers[name]}
                  onChange={handleChange}
                  className="w-full px-4 py-3 text-lg rounded-lg border border-gray-300 
                             focus:ring-2 focus:ring-gray-600 outline-none transition"
                  required
                />
              </div>
            ))}

            {/* BUTTON */}
            <div className="md:col-span-2">
              <button
                type="submit"
                disabled={loading}
                className={`w-full py-4 text-lg font-bold rounded-lg text-white shadow 
                  transition ${
                    loading
                      ? "bg-gray-500"
                      : "bg-gray-800 hover:bg-gray-900"
                  }`}
              >
                {loading ? "Updating..." : "Save Offer Settings"}
              </button>
            </div>
          </form>

          {/* MESSAGE BOX */}
          {message && (
            <div
              className={`mt-6 p-4 rounded-lg text-center text-lg font-semibold ${
                message.includes("SUCCESS")
                  ? "bg-green-100 text-green-700 border border-green-300"
                  : "bg-red-100 text-red-700 border border-red-300"
              }`}
            >
              {message}
            </div>
          )}
        </div>

        <p className="text-center text-gray-500 mt-6">
          Offers update instantly for all customers.
        </p>
      </div>
    </div>
  );
}
